module.exports = __webpack_public_path__ + "img/feature-02-tipprunde.e517e80b.svg";